import { getFetchableStaticUrl, getUrlForStaticApi } from "./urlStaticFiles";

const injectBaseHref = (html, baseUrl) => {
  if (/<base[\s>]/i.test(html)) return html;
  if (/<head[^>]*>/i.test(html)) {
    return html.replace(/<head([^>]*)>/i, `<head$1><base href="${baseUrl}">`);
  }
  return `<!DOCTYPE html><html><head><base href="${baseUrl}"></head><body>${html}</body></html>`;
};

const isAppShellHtml = (html) => /id=["']root["']/i.test(html) && /\/static\/js\//i.test(html);

const isHtmlDocument = (html) => (
  Boolean(html)
  && html.length > 100
  && /<!doctype html|<html[\s>]/i.test(html)
  && !isAppShellHtml(html)
);

const fetchStaticHtml = async (url) => {
  const fullUrl = getUrlForStaticApi(url);
  if (!fullUrl) throw new Error("Empty url");

  const baseUrl = fullUrl.replace(/[^/]*$/, "");
  const proxyUrl = getFetchableStaticUrl(url);
  const urlsToTry = proxyUrl === fullUrl ? [fullUrl] : [proxyUrl, fullUrl];

  let lastError;
  for (const fetchUrl of urlsToTry) {
    try {
      const response = await fetch(fetchUrl);
      if (!response.ok) {
        lastError = new Error(`HTTP ${response.status}`);
        continue;
      }
      const html = await response.text();
      if (!isHtmlDocument(html)) {
        lastError = new Error("Invalid HTML response");
        continue;
      }
      return injectBaseHref(html, baseUrl);
    } catch (error) {
      lastError = error;
    }
  }

  throw lastError || new Error("Failed to fetch HTML");
};

export default fetchStaticHtml;
